export default __webpack_public_path__ + "static/media/money.ddd6709d.png";